import React, { Component } from 'react';
import { Cookies } from 'react-cookie';
import {Element, scroller} from 'react-scroll';
import {Helmet} from 'react-helmet';
import _ from 'lodash';

// import LearnMore from '../../components/Forms/LearnMoreInline';
import ReasonsMedicaid from '../../components/Reasons/ReasonsMedicaid';
// import CustomerConnect from '../../components/CustomerConnect/CustomerConnect.jsx';
import ScrollButton from '../../components/Header/ScrollButton.jsx';
import {encodeUrl} from '../../helpers/quiz';
import * as RouteHelpers from '../../helpers/routes';
import * as ResultHelpers from '../../helpers/results';

class ResultsMedicaid extends Component {
  state = {
    loading: true,
    url: `${process.env.REACT_APP_API_URL}/plans/individual`,
    formResults: this.props.quiz.fieldValues,
    mounted: false,
    trackOnce: true
  };

  componentDidMount () {
    const p = _.clone(this.props);
    const cookies = new Cookies();

    if (cookies.get('CDPHP_myResults') && this.props.showResults) { // Check for cookie
      this.setState({ formResults: cookies.get('CDPHP_myResults') });
    }

    if (p.route !== 'quote') {
      const fieldValues = _.merge({}, p.quiz.fieldValues, {'ResultsType': 'ResultsMedicaid'});
      const resultString = encodeUrl(fieldValues);
      cookies.set('CDPHP_quoteString', resultString, { path: '/' });
      RouteHelpers.history.push('/quote/' + resultString);
    } else if (Object.keys(p.rest.quote).length === 0) {
      p.reducer({fieldValues: p.quiz.fieldValues, url: 'individual'});
      p.updateHeaderPhone('866-692-3747');
      p.toggleInQuiz(false);
      p.toggleInResults(true);
      p.updateResultsFooter(true, {
        'medicaid': 'true',
        'jdpower': 'true',
        'results': 'true'
      });
      p.updateResultsRatings(true, {
        'medicaid': 'true',
        'jdpower': 'true'
      });
      p.updateHeaderScroller(
        <ScrollButton
          text='Contact Us'
          scrollName='learnForm'
          scrollOpts={{
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -200
          }}
        />
      );
    }
  }

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {rest} = p;

    if (_.isObject(rest.quote) && Object.keys(rest.quote).length && state.trackOnce === true) {
      // set state once we have data from the server on the selected plan:
      ResultHelpers.sendAnalyticsOnQuote(p.quiz.fieldValues, rest);

      return {
        loading: false,
        trackOnce: false
      };
    }

    return null; // if no state mutations are required at this time
  }

  componentWillUnmount () {
    this.setState({mounted: false});
  }

  // Create Cookie Here
  setCookie = (data) => {
    const cookies = new Cookies();
    cookies.set('CDPHP_myResults', data, { path: '/' });
  }

  scrollTo () {
    scroller.scrollTo('learnForm', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -100
    });
  }

  render () {
    let loading;
    let showCHP;
    let familyType = this.props.quiz.fieldValues.FamilyType;
    let numberOfKids = this.props.quiz.fieldValues.KidsCount;
    let childLang = null;
    let heading = 'for you.';
    // let area = 'MedicaidOnly';
    let medicaidOnly = ' that covers a wide variety of health care services';
    // let title = 'Your CDPHP Medicaid Plan Quote';

    if (this.state.loading) {
      loading = 'loading';
    }

    if (familyType === 'Couple') {
      heading = <span className='break'>for you and your spouse.</span>;
    }

    if (familyType === 'CoupleChildren' || familyType === 'IndividualChildren') {
      medicaidOnly = null;
      if (numberOfKids > 0) {
        heading = <span className='break'>for your family.</span>;
        if (numberOfKids === 1) {
          childLang = 'child is';
        } else {
          childLang = 'children are';
        }
        showCHP = <span>Your {numberOfKids} {childLang} eligible for free <strong>Child Health Plus</strong>.</span>;
        // area = 'MedicaidCHP';
        // title = 'Your CDPHP Medicaid & Child Health Plus Plan Quote';
      }
    }

    // Send Location Through

    // const cookies = new Cookies();
    // let Loc = this.props.location;
    // if (cookies.get('CDPHP_myResults')) {
    //   Loc = cookies.get('CDPHP_myResults').Location;
    // }

    return (
      <div className={'single ' + loading}>
        <Helmet>
          <title>Your CDPHP Medicaid Plan Quote</title>
        </Helmet>
        <section id='intro'>
          <div className='wrap'>
            <h1>We have just the solution {heading}</h1>
            <h3>You may be eligible for <strong>free</strong> or <strong>low-cost Medicaid coverage</strong>{medicaidOnly}.* {showCHP}</h3>
          </div>
        </section>

        <ReasonsMedicaid medicaid='true' />

        <Element name='learnForm'>
          <section className='divide p60 mt60'>
            <div className='wrap'>
              <h4>To confirm that you qualify, and get help making the best choice,<br /> <strong>call us at <a href='tel:866-692-3747' className='tel'>866-692-3747</a></strong>.</h4>
              <p className='text-center nysh'>You can also visit the <a href='https://nystateofhealth.ny.gov/' target='_blank' rel='noopener noreferrer'>New York State of Health</a> to find coverage.</p>
            </div>
          </section>
        </Element>

        {/* <section className='contact'>
          <div className='wrap sm text-center'>
            <h5>We&rsquo;re here to help.</h5>
            <div>
              Call us at <a href='tel:866-692-3747' className='tel phoneswap'>866-692-3747</a>
              {Loc && Loc.loc && <CustomerConnect zip={Loc.loc.Zip} />}
            </div>
          </div>
        </section> */}
      </div>

    );
  }
}

export default ResultsMedicaid;



// WEBPACK FOOTER //
// ./src/containers/Results/ResultsMedicaid.jsx